import { render, staticRenderFns } from "./customerfrm.vue?vue&type=template&id=e277e1e4"
import script from "./customerfrm.vue?vue&type=script&lang=js"
export * from "./customerfrm.vue?vue&type=script&lang=js"
import style0 from "./customerfrm.vue?vue&type=style&index=0&id=e277e1e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports